import React, { type FC, useState } from "react";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import * as Styles from "./styles/SpecList";
import * as SummaryStyles from "./styles/SummaryEcoConsumption";
import * as IconWrapper from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import type { EcoConsumptionSectionType } from "../../../../../shared-modules/eco-consumption-section/types/EcoConsumptionType";
import { IntegratedEcoConsumptionSection } from "../../../../../shared-modules/eco-consumption-section/components/IntegratedEcoConsumptionSection";
import { trackExpandSpecCategory } from "../../../utils/tracking";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";

const SummaryEcoConsumption: FC<{ ecoConsumptionConfiguration: EcoConsumptionSectionType }> = (props): JSX.Element => {
    const { ecoConsumptionConfiguration } = props;

    const [isOpen, setIsOpen] = useState(true);

    const toggleState = (): void => {
        if (!isOpen) {
            trackExpandSpecCategory("eco");
        }
        setIsOpen(!isOpen);
    };

    return (
        <Styles.Wrapper isOpen={isOpen}>
            <Styles.DropDownAction
                as="a"
                onClick={toggleState}
                id="summary-eco-consumption-header"
                aria-expanded={isOpen}
                aria-controls="summary-eco-consumption"
            >
                <Styles.DropDownTitle role="heading" aria-level={4}>
                    {ecoConsumptionConfiguration.title}
                </Styles.DropDownTitle>
                <IconWrapper.ToggleIconWrapper isDown={isOpen} aria-hidden="true">
                    <Icon variant="chevronDown" />
                </IconWrapper.ToggleIconWrapper>
            </Styles.DropDownAction>
            {isOpen && (
                <Styles.DropDown id="summary-eco-consumption" aria-labelledby="summary-eco-consumption-header">
                    <SummaryStyles.EcoConsumptionWrapper>
                        <IntegratedEcoConsumptionSection
                            ecoConsumptionConfiguration={ecoConsumptionConfiguration}
                            PopoverTooltip={(tooltip: { content: string }) => (
                                <Popover showOnClick useHTML content={tooltip.content} />
                            )}
                        />
                    </SummaryStyles.EcoConsumptionWrapper>
                </Styles.DropDown>
            )}
        </Styles.Wrapper>
    );
};

export default SummaryEcoConsumption;
